import { useCallback } from "react"

import { selectSurfacePreference } from "../containers/User/redux/ui-preferences.selectors.ts"
import { type SurfaceKey } from "../containers/User/redux/ui-preferences.types.ts"
import { storeSurfacePreference } from "../containers/User/redux/ui-preferences.thunks.ts"
import { useAppDispatch } from "./use-app-dispatch.ts"
import { useAppSelector } from "./use-app-selector.ts"

/**
 * Remembers one screen's choice against the signed-in user, addressed by a flat key.
 * Passing `null` clears the choice, so the next read returns `fallback` again.
 */
export const useSurfacePreference = <T>(
  key: SurfaceKey,
  fallback: T
): [T, (value: T | null) => void] => {
  const dispatch = useAppDispatch()
  const value = useAppSelector((state) =>
    selectSurfacePreference(state, key, fallback)
  )

  const store = useCallback(
    (next: T | null) => {
      void dispatch(storeSurfacePreference({ key, value: next }))
    },
    [dispatch, key]
  )

  return [value, store]
}
